import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {OrderService} from "../service/order.service";

@Component({
  selector: 'fb-order-cancellation-dialog',
  templateUrl: './order-cancellation-dialog.component.html',
  styleUrls: ['./order-cancellation-dialog.component.scss']
})
export class OrderCancellationDialogComponent {

	public reason: string = "";
	public showError: boolean = false;

	constructor(
		private _dialogRef: MatDialogRef<OrderCancellationDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: { orderId: number },
		private _orderService: OrderService
	) {
	}

	public onClose(): void {
		this._dialogRef.close();
	}

	public onSubmit(): void {
		if(this.reason) {
			this._orderService.cancelOrder(this.data.orderId, this.reason);
		}
		else {
			this.showError = true;
			setTimeout(() => {
				this.showError = false;
			}, 4000)
		}
	}
}
